'use client';

import { useEffect } from 'react';

/**
 * Hook to set body background color at layout level
 * 
 * @param backgroundColor - The background color to set (e.g., 'black', 'white', '#000000')
 * @param fallbackColor - The color to restore on cleanup (optional)
 */
export function useLayoutBodyBackground(backgroundColor: string, fallbackColor?: string) {
  useEffect(() => {
    // Store current background to restore later
    const previousBackground = document.body.style.backgroundColor;
    
    // Set the new background
    document.body.style.backgroundColor = backgroundColor;
    
    // Cleanup: restore previous background or fallback
    return () => {
      document.body.style.backgroundColor = fallbackColor || previousBackground;
    };
  }, [backgroundColor, fallbackColor]);
}